import portal from "../assets/school_portal.png"
import vtu from "../assets/vtu.png"
import pos from "../assets/pos.png"
import solar_cctv from "../assets/solar_cctv.png"
import visual from "../assets/visual.png"
import stream from "../assets/stream.jpg"

const WorkCardData = [
    {
        imgsrc: portal,
        title: "School Management System",
        text: "Fully Automated School Management System for Staff, Student, Administration, Results, Finance and More. Beyond the Four-walls of the school, this Application Bridge the Distance gap between Parent/ Students and The School",
        view: "https://fulfilledchildrenschools.com/school/",
    },
    {
        imgsrc: vtu,
        title: "Dynamic VTU Portal",
        text: "VTU Subscription Website Platform, Quality, Secured for all Subscription Services with with Payment Gateway",
        view: "https://ekreat.com/subscriptions",
    },
    {
        imgsrc: pos,
        title: "Supermarket App",
        text: "Manage Your Supermarket Sales with Our Dynamic Point of Sales Application System for Full Profitability",
        view: "https://tkhschool.com/lifecare/",
    },
        {
        imgsrc: solar_cctv,
        title: "Solar/ CCTV Installation",
        text: "We Install Solar System and CCTV System inline with Best Practise.",
        view: "https://ekreat.com/",
    },
    {
        imgsrc: visual,
        title: "Church/ Event/ Studio Visual Setup",
        text: "We Setup Visual Studio for Churches, Mosque, Events etc of various media capacity including LED Screen Installation.",
        view: "https://ekreat.com/",
    },
    {
        imgsrc: stream,
        title: "Quality Streaming Service",
        text: "Let your Audience catch the beauty of the Moment, Reach More Audience with Ekreat Media Solution",
        view: "https://youtu.be/VPDzFcZjmMw",
    },
];
export default WorkCardData;